import { atom } from 'jotai';

export const technicalMetadataWarningsAtom = atom([]);
technicalMetadataWarningsAtom.debugLabel = 'technicalMetadataWarnings';

export const editingQAChecklistAtom = atom(false);
editingQAChecklistAtom.debugLabel = 'editingQAChecklistAtom';

export const metadataIsUpdatingAtom = atom(false);
metadataIsUpdatingAtom.debugLabel = 'metadataIsUpdating';

export const sourceDataIsUpdatingAtom = atom(false);
sourceDataIsUpdatingAtom.debugLabel = 'sourceDataIsUpdating';

export const approvalInProgressAtom = atom(false);
approvalInProgressAtom.debugLabel = 'approvalInProgressAtom';
